/** Planning scenario, not accounting profit or a forecast. All amounts in USD. */
export function calculateContribution(input) {
    if (Object.values(input).some((n) => !Number.isFinite(n) || n < 0) || input.paidMonths <= 0)
        return null;
    const monthlyContribution = input.netMonthlyRevenue - input.variableMonthlyCost;
    const episodeContribution = monthlyContribution * input.paidMonths - input.acquisitionCost;
    const monthlyAfterReplacement = monthlyContribution - input.acquisitionCost / input.paidMonths;
    return {
        monthlyContribution,
        episodeContribution,
        monthlyAfterReplacement,
        breakEvenActivePayers: monthlyAfterReplacement > 0
            ? Math.ceil((input.fixedMonthlyCost + input.freeMonthlyCost) / monthlyAfterReplacement) : null,
    };
}
//# sourceMappingURL=contribution-model.js.map